import React from "react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-border bg-background"
        >
            <div className="container-edge py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
                <div className="md:col-span-5">
                    <p className="font-display text-2xl font-medium tracking-tight">
                        Alfie Carter
                    </p>
                    <p className="mt-3 text-[13px] text-foreground/65 max-w-sm">
                        Temporary Spaces. Built With Purpose. 3D Event CAD &
                        Spatial Visualisation — based in London.
                    </p>
                </div>
                <div className="md:col-span-3">
                    <p className="overline">Navigate</p>
                    <ul className="mt-4 space-y-2 text-[13px]">
                        <li><a href="#services" className="hover:opacity-70 transition-opacity">Services</a></li>
                        <li><a href="#process" className="hover:opacity-70 transition-opacity">Process</a></li>
                        <li><a href="#portfolio" className="hover:opacity-70 transition-opacity">Portfolio</a></li>
                        <li><a href="#about" className="hover:opacity-70 transition-opacity">About</a></li>
                        <li><a href="#contact" className="hover:opacity-70 transition-opacity">Contact</a></li>
                    </ul>
                </div>
                <div className="md:col-span-4">
                    <p className="overline">Get in touch</p>
                    <a
                        href="mailto:alfie@alfiecarter.org"
                        className="mt-4 block text-[15px] font-display tracking-tight hover:opacity-70 transition-opacity"
                    >
                        alfie@alfiecarter.org
                    </a>
                    <a
                        href="tel:+447861762191"
                        className="mt-2 block text-[14px] tracking-tight text-foreground/70 hover:text-foreground transition-colors"
                    >
                        07861 762 191
                    </a>
                    <p className="mt-3 text-[13px] text-foreground/65">
                        London — working UK-wide.
                    </p>
                </div>
            </div>
            <div className="border-t border-border">
                <div className="container-edge py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                    <p className="text-[11px] tracking-[0.15em] uppercase text-foreground/50">
                        © {new Date().getFullYear()} Alfie Carter. All rights reserved.
                    </p>
                    <p className="text-[11px] tracking-[0.15em] uppercase text-foreground/50">
                        3D Event CAD · Spatial Visualisation · London
                    </p>
                </div>
            </div>
        </footer>
    );
}
